import { c as _c } from "react/compiler-runtime";
export const CategoryGalleryLoadingSkeleton: React.FC<{
  className?: string;
}> = props => {
  const $ = _c(4);
  const t0 = `overflow-hidden bg-white ${props.className || ""}`;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="mb-3 h-[18px] w-64 animate-pulse rounded-xs bg-blue-800 lg:h-[22px]" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="-mx-2"><div className="flex overflow-x-hidden">{Array.from({
          length: 6
        }).map(_temp)}</div></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t0) {
    t3 = <div className={t0}>{t1}{t2}</div>;
    $[2] = t0;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
function _temp(_, index) {
  return <div key={index} className="flex min-h-[218px] w-full shrink-0 flex-col gap-2 px-2 text-sm xs:w-1/2 sm:w-1/3 md:w-1/4 lg:w-1/5 xl:w-1/6"><div className="relative h-36 w-full animate-pulse rounded-xl bg-gray-200" /><div className="mt-3 h-[20px] w-2/3 animate-pulse rounded-xs bg-blue-800" /><div className="h-[20px] w-1/2 animate-pulse rounded-xs bg-gray-500" /></div>;
}